import axios from "axios";

const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL || "http://localhost:8000/api";

function getCookie(name) {
  const cookies = document.cookie ? document.cookie.split(";") : [];
  for (let c of cookies) {
    const cookie = c.trim();
    if (cookie.startsWith(name + "=")) {
      return decodeURIComponent(cookie.substring(name.length + 1));
    }
  }
  return null;
}

const apiClient = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: true,
});

apiClient.defaults.xsrfCookieName = "csrftoken";
apiClient.defaults.xsrfHeaderName = "X-CSRFToken";

// на случай, если axios не подставил X-CSRFToken (например cookie еще не была установлена),
// принудительно добавим его для refresh
apiClient.interceptors.request.use((config) => {
  if (config?.url?.includes("/jwt/auth/refresh/")) {
    const csrf = getCookie("csrftoken");
    if (csrf) {
      config.headers = config.headers || {};
      if (!config.headers["X-CSRFToken"]) {
        config.headers["X-CSRFToken"] = csrf;
      }
    }
  }
  return config;
});

let isRefreshing = false;
let queue = [];

function processQueue(err) {
  queue.forEach(({ resolve, reject }) => (err ? reject(err) : resolve()));
  queue = [];
}

apiClient.interceptors.response.use(
  (r) => r,
  async (error) => {
    const original = error?.config;
    const status = error?.response?.status;

    if (!original || status !== 403 || original._retry) {
      return Promise.reject(error);
    }

    const url = original.url || "";
    const isAuthEndpoint =
      url.includes("/jwt/auth/login/") ||
      url.includes("/jwt/auth/logout/") ||
      url.includes("/jwt/auth/refresh/");

    if (isAuthEndpoint) return Promise.reject(error);

    const refreshSignal =
      error?.response?.headers?.["x-auth-refresh"] === "1" ||
      error?.response?.data?.code === "access_needs_refresh";

    if (!refreshSignal) return Promise.reject(error);

    original._retry = true;

    if (isRefreshing) {
      return new Promise((resolve, reject) => queue.push({ resolve, reject })).then(() =>
        apiClient(original)
      );
    }

    isRefreshing = true;

    try {
      await apiClient.post("/jwt/auth/refresh/", {});
      processQueue(null);
      return apiClient(original);
    } catch (err) {
      processQueue(err);
      return Promise.reject(err);
    } finally {
      isRefreshing = false;
    }
  }
);

export default apiClient;